import React, { useState } from 'react';

/* ─── Static data ─────────────────────────────────────────── */
const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
const INCOME_DATA  = [42000,48000,51000,47000,55000,60000,58000,63000,57000,65000,70000,95000];
const EXPENSE_DATA = [30000,33000,35000,32000,38000,41000,39000,43000,40000,44000,47000,71000];

const PL_ROWS = [
  { label:'Sales Revenue',    amount:95000,  type:'income'   },
  { label:'Service Revenue',  amount:12000,  type:'income'   },
  { label:'Total Revenue',    amount:107000, type:'total'    },
  { label:'COGS',             amount:47000,  type:'expense'  },
  { label:'Gross Profit',     amount:60000,  type:'subtotal' },
  { label:'Salaries Expense', amount:18000,  type:'expense'  },
  { label:'Rent Expense',     amount:6000,   type:'expense'  },
  { label:'Marketing',        amount:6200,   type:'expense'  },
  { label:'Utilities',        amount:1800,   type:'expense'  },
  { label:'Total Expenses',   amount:32000,  type:'total'    },
  { label:'Net Income',       amount:28000,  type:'net'      },
];

const BS_ROWS = {
  assets:      [{ label:'Cash', amount:45200 },{ label:'Accounts Receivable', amount:12800 },{ label:'Inventory', amount:33500 },{ label:'Fixed Assets', amount:120000 },{ label:'Total Assets', amount:211500, total:true }],
  liabilities: [{ label:'Accounts Payable', amount:8400 },{ label:'Short-term Loans', amount:15000 },{ label:'Total Liabilities', amount:23400, total:true }],
  equity:      [{ label:'Owner Equity', amount:188100 },{ label:'Total Equity', amount:188100, total:true }],
};

const TB_ROWS = [
  { account:'Cash',                debit:45200,  credit:0      },
  { account:'Accounts Receivable', debit:12800,  credit:0      },
  { account:'Inventory',           debit:33500,  credit:0      },
  { account:'Fixed Assets',        debit:120000, credit:0      },
  { account:'Accounts Payable',    debit:0,      credit:8400   },
  { account:'Short-term Loans',    debit:0,      credit:15000  },
  { account:'Owner Equity',        debit:0,      credit:188100 },
  { account:'Sales Revenue',       debit:0,      credit:95000  },
  { account:'COGS',                debit:47000,  credit:0      },
  { account:'Salaries Expense',    debit:18000,  credit:0      },
  { account:'Rent Expense',        debit:6000,   credit:0      },
];

const LEDGER_ENTRIES = [
  { date:'2026-01-05', description:'Sales Invoice #001', debit:15000, credit:0,     balance:15000  },
  { date:'2026-01-12', description:'Cash Received',      debit:0,     credit:10000, balance:5000   },
  { date:'2026-02-03', description:'Sales Invoice #002', debit:20000, credit:0,     balance:25000  },
  { date:'2026-02-18', description:'Cash Received',      debit:0,     credit:18000, balance:7000   },
  { date:'2026-03-07', description:'Sales Invoice #003', debit:12800, credit:0,     balance:19800  },
];

const AR_AGEING_SUMMARY = [
  { customer:'Acme Corp',     current:5000, days30:2000, days60:1500, days90:800,  over90:200  },
  { customer:'Beta Ltd',      current:3000, days30:1500, days60:800,  days90:0,    over90:0    },
  { customer:'Gamma Traders', current:8000, days30:3000, days60:2000, days90:1000, over90:500  },
  { customer:'Delta Inc',     current:1500, days30:0,    days60:500,  days90:0,    over90:0    },
];

const AP_AGEING_SUMMARY = [
  { supplier:'Alpha Supplies', current:4000, days30:1500, days60:1000, days90:500, over90:0   },
  { supplier:'Beta Wholesale', current:6000, days30:2500, days60:800,  days90:200, over90:100 },
  { supplier:'Gamma Parts',    current:2000, days30:500,  days60:200,  days90:0,   over90:0   },
];

const AR_AGEING_DETAILS = [
  { customer:'Acme Corp',     invoice:'INV-001', date:'2026-01-15', dueDate:'2026-02-14', amount:5000, status:'Current'  },
  { customer:'Acme Corp',     invoice:'INV-002', date:'2025-12-10', dueDate:'2026-01-09', amount:2000, status:'30 Days'  },
  { customer:'Beta Ltd',      invoice:'INV-003', date:'2026-02-01', dueDate:'2026-03-02', amount:3000, status:'Current'  },
  { customer:'Gamma Traders', invoice:'INV-004', date:'2025-11-05', dueDate:'2025-12-05', amount:1000, status:'90+ Days' },
  { customer:'Gamma Traders', invoice:'INV-005', date:'2026-01-20', dueDate:'2026-02-19', amount:8000, status:'Current'  },
];

const AP_AGEING_DETAILS = [
  { supplier:'Alpha Supplies', invoice:'PO-001', date:'2026-01-10', dueDate:'2026-02-09', amount:4000, status:'Current'  },
  { supplier:'Beta Wholesale', invoice:'PO-002', date:'2025-12-20', dueDate:'2026-01-19', amount:2500, status:'30 Days'  },
  { supplier:'Beta Wholesale', invoice:'PO-003', date:'2026-02-05', dueDate:'2026-03-06', amount:6000, status:'Current'  },
  { supplier:'Gamma Parts',    invoice:'PO-004', date:'2025-11-15', dueDate:'2025-12-15', amount:200,  status:'90+ Days' },
];

/* ─── Report Cards config ─────────────────────────────────── */
const REPORT_CARDS = [
  {
    id: 'trial-balance',
    title: 'Trial Balance',
    description: 'A trial balance displays summary of all ledger balances, and helps in checking whether the transactions are correct and balanced.',
  },
  {
    id: 'ledger-report',
    title: 'Ledger Report',
    description: 'The ledger report contains the classified and detailed information of all the individual accounts including the debit and credit aspects.',
  },
  {
    id: 'balance-sheet',
    title: 'Balance Sheet',
    description: 'This report gives you an immediate status of your accounts at a specified date. You can call it a "Snapshot" view of the current position (day) of the financial year.',
  },
  {
    id: 'ar-ageing-summary',
    title: 'Account Receivable Ageing Report (Summary)',
    description: 'This report shows summary of all the sales pending invoices in mentioned days range as per the due date.',
  },
  {
    id: 'ap-ageing-summary',
    title: 'Account Payable Ageing Report (Summary)',
    description: 'This report shows summary of all the purchase pending invoices in mentioned days range as per the due date.',
  },
  {
    id: 'ar-ageing-details',
    title: 'Account Receivable Ageing Details (Details)',
    description: 'This report shows details of all the sales pending invoices in mentioned days range as per the due date.',
  },
  {
    id: 'ap-ageing-details',
    title: 'Account Payable Ageing Details (Details)',
    description: 'This report shows details of all the purchase pending invoices in mentioned days range as per the due date.',
  },
];

/* ─── Helper components ───────────────────────────────────── */
const BarChart = ({ incomeData, expenseData, months }) => {
  const max = Math.max(...incomeData, ...expenseData);
  return (
    <div style={{ display:'flex', gap:'0.35rem', alignItems:'flex-end', height:160, padding:'0 0.25rem' }}>
      {months.map((m, i) => (
        <div key={m} style={{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', gap:2 }}>
          <div style={{ display:'flex', gap:2, alignItems:'flex-end', width:'100%' }}>
            <div style={{ flex:1, background:'#6366f1', borderRadius:'3px 3px 0 0', height:`${(incomeData[i]/max)*130}px`, minHeight:4 }} />
            <div style={{ flex:1, background:'#f59e0b', borderRadius:'3px 3px 0 0', height:`${(expenseData[i]/max)*130}px`, minHeight:4 }} />
          </div>
          <span style={{ fontSize:'0.65rem', color:'var(--etpos-text-muted,#64748b)' }}>{m}</span>
        </div>
      ))}
    </div>
  );
};

const StatusBadge = ({ status }) => {
  const color = status === 'Current' ? { bg:'#dcfce7', text:'#166534' } :
                status === '30 Days' ? { bg:'#fef9c3', text:'#854d0e' } :
                status === '60 Days' ? { bg:'#ffedd5', text:'#9a3412' } :
                                       { bg:'#fee2e2', text:'#991b1b' };
  return (
    <span style={{ background:color.bg, color:color.text, padding:'0.2rem 0.6rem', borderRadius:'999px', fontSize:'0.72rem', fontWeight:700 }}>
      {status}
    </span>
  );
};

const fmt = (n) => `$${n.toLocaleString('en-US', { minimumFractionDigits:2 })}`;

/* ─── Report detail views ─────────────────────────────────── */
const TrialBalanceView = () => {
  const totalDebit  = TB_ROWS.reduce((s,r) => s + r.debit, 0);
  const totalCredit = TB_ROWS.reduce((s,r) => s + r.credit, 0);
  return (
    <div className="acc-table-wrapper">
      <table className="acc-table">
        <thead>
          <tr>
            <th>Account</th>
            <th className="text-right">Debit (USD)</th>
            <th className="text-right">Credit (USD)</th>
          </tr>
        </thead>
        <tbody>
          {TB_ROWS.map((r,i) => (
            <tr key={i}>
              <td>{r.account}</td>
              <td className="text-right" style={{ color: r.debit  ? '#10b981' : '#94a3b8' }}>{r.debit  ? fmt(r.debit)  : '—'}</td>
              <td className="text-right" style={{ color: r.credit ? '#ef4444' : '#94a3b8' }}>{r.credit ? fmt(r.credit) : '—'}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr style={{ fontWeight:700, background:'var(--etpos-bg,#f8fafc)' }}>
            <td>Total</td>
            <td className="text-right" style={{ color:'#10b981' }}>{fmt(totalDebit)}</td>
            <td className="text-right" style={{ color:'#ef4444' }}>{fmt(totalCredit)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

const LedgerReportView = () => (
  <div className="acc-table-wrapper">
    <table className="acc-table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Description</th>
          <th className="text-right">Debit</th>
          <th className="text-right">Credit</th>
          <th className="text-right">Balance</th>
        </tr>
      </thead>
      <tbody>
        {LEDGER_ENTRIES.map((r,i) => (
          <tr key={i}>
            <td>{r.date}</td>
            <td>{r.description}</td>
            <td className="text-right" style={{ color:'#10b981' }}>{r.debit  ? fmt(r.debit)  : '—'}</td>
            <td className="text-right" style={{ color:'#ef4444' }}>{r.credit ? fmt(r.credit) : '—'}</td>
            <td className="text-right" style={{ fontWeight:600 }}>{fmt(r.balance)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const BalanceSheetView = () => (
  <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(280px,1fr))', gap:'1rem' }}>
    <div className="acc-card">
      <h3 className="acc-card-title">Assets</h3>
      <table className="acc-table">
        <tbody>
          {BS_ROWS.assets.map((r,i) => (
            <tr key={i} style={r.total ? { fontWeight:700, background:'var(--etpos-bg,#f8fafc)' } : {}}>
              <td style={{ paddingLeft: r.total ? '1rem' : '1.75rem' }}>{r.label}</td>
              <td className="text-right">{fmt(r.amount)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    <div style={{ display:'flex', flexDirection:'column', gap:'1rem' }}>
      <div className="acc-card">
        <h3 className="acc-card-title">Liabilities</h3>
        <table className="acc-table">
          <tbody>
            {BS_ROWS.liabilities.map((r,i) => (
              <tr key={i} style={r.total ? { fontWeight:700, background:'var(--etpos-bg,#f8fafc)' } : {}}>
                <td style={{ paddingLeft: r.total ? '1rem' : '1.75rem' }}>{r.label}</td>
                <td className="text-right">{fmt(r.amount)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="acc-card">
        <h3 className="acc-card-title">Equity</h3>
        <table className="acc-table">
          <tbody>
            {BS_ROWS.equity.map((r,i) => (
              <tr key={i} style={r.total ? { fontWeight:700, background:'var(--etpos-bg,#f8fafc)' } : {}}>
                <td style={{ paddingLeft: r.total ? '1rem' : '1.75rem' }}>{r.label}</td>
                <td className="text-right">{fmt(r.amount)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

const ARAgeingSummaryView = () => (
  <div className="acc-table-wrapper">
    <table className="acc-table">
      <thead>
        <tr>
          <th>Customer</th>
          <th className="text-right">Current</th>
          <th className="text-right">1–30 Days</th>
          <th className="text-right">31–60 Days</th>
          <th className="text-right">61–90 Days</th>
          <th className="text-right">90+ Days</th>
          <th className="text-right">Total</th>
        </tr>
      </thead>
      <tbody>
        {AR_AGEING_SUMMARY.map((r,i) => {
          const total = r.current + r.days30 + r.days60 + r.days90 + r.over90;
          return (
            <tr key={i}>
              <td style={{ fontWeight:600 }}>{r.customer}</td>
              <td className="text-right">{fmt(r.current)}</td>
              <td className="text-right">{fmt(r.days30)}</td>
              <td className="text-right">{fmt(r.days60)}</td>
              <td className="text-right">{fmt(r.days90)}</td>
              <td className="text-right" style={{ color: r.over90 ? '#ef4444' : '#94a3b8' }}>{fmt(r.over90)}</td>
              <td className="text-right" style={{ fontWeight:700 }}>{fmt(total)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

const APAgeingSummaryView = () => (
  <div className="acc-table-wrapper">
    <table className="acc-table">
      <thead>
        <tr>
          <th>Supplier</th>
          <th className="text-right">Current</th>
          <th className="text-right">1–30 Days</th>
          <th className="text-right">31–60 Days</th>
          <th className="text-right">61–90 Days</th>
          <th className="text-right">90+ Days</th>
          <th className="text-right">Total</th>
        </tr>
      </thead>
      <tbody>
        {AP_AGEING_SUMMARY.map((r,i) => {
          const total = r.current + r.days30 + r.days60 + r.days90 + r.over90;
          return (
            <tr key={i}>
              <td style={{ fontWeight:600 }}>{r.supplier}</td>
              <td className="text-right">{fmt(r.current)}</td>
              <td className="text-right">{fmt(r.days30)}</td>
              <td className="text-right">{fmt(r.days60)}</td>
              <td className="text-right">{fmt(r.days90)}</td>
              <td className="text-right" style={{ color: r.over90 ? '#ef4444' : '#94a3b8' }}>{fmt(r.over90)}</td>
              <td className="text-right" style={{ fontWeight:700 }}>{fmt(total)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

const ARAgeingDetailsView = () => (
  <div className="acc-table-wrapper">
    <table className="acc-table">
      <thead>
        <tr>
          <th>Customer</th>
          <th>Invoice #</th>
          <th>Invoice Date</th>
          <th>Due Date</th>
          <th className="text-right">Amount</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {AR_AGEING_DETAILS.map((r,i) => (
          <tr key={i}>
            <td style={{ fontWeight:600 }}>{r.customer}</td>
            <td>{r.invoice}</td>
            <td>{r.date}</td>
            <td>{r.dueDate}</td>
            <td className="text-right">{fmt(r.amount)}</td>
            <td><StatusBadge status={r.status} /></td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const APAgeingDetailsView = () => (
  <div className="acc-table-wrapper">
    <table className="acc-table">
      <thead>
        <tr>
          <th>Supplier</th>
          <th>PO #</th>
          <th>Invoice Date</th>
          <th>Due Date</th>
          <th className="text-right">Amount</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {AP_AGEING_DETAILS.map((r,i) => (
          <tr key={i}>
            <td style={{ fontWeight:600 }}>{r.supplier}</td>
            <td>{r.invoice}</td>
            <td>{r.date}</td>
            <td>{r.dueDate}</td>
            <td className="text-right">{fmt(r.amount)}</td>
            <td><StatusBadge status={r.status} /></td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

const IncomeVsExpenseView = () => (
  <div className="acc-card">
    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'1.25rem', flexWrap:'wrap', gap:'0.5rem' }}>
      <h3 className="acc-card-title" style={{ margin:0 }}>Income vs Expense — Monthly</h3>
      <div style={{ display:'flex', gap:'1rem', fontSize:'0.8rem' }}>
        <span style={{ display:'flex', alignItems:'center', gap:'0.35rem' }}>
          <span style={{ width:12, height:12, background:'#6366f1', borderRadius:2, display:'inline-block' }} />Income
        </span>
        <span style={{ display:'flex', alignItems:'center', gap:'0.35rem' }}>
          <span style={{ width:12, height:12, background:'#f59e0b', borderRadius:2, display:'inline-block' }} />Expense
        </span>
      </div>
    </div>
    <BarChart incomeData={INCOME_DATA} expenseData={EXPENSE_DATA} months={MONTHS} />
    <div style={{ marginTop:'1.5rem' }}>
      <table className="acc-table">
        <thead>
          <tr><th>Month</th><th className="text-right">Income</th><th className="text-right">Expense</th><th className="text-right">Net</th></tr>
        </thead>
        <tbody>
          {MONTHS.map((m,i) => {
            const net = INCOME_DATA[i] - EXPENSE_DATA[i];
            return (
              <tr key={m}>
                <td>{m}</td>
                <td className="text-right" style={{ color:'#10b981' }}>${INCOME_DATA[i].toLocaleString()}</td>
                <td className="text-right" style={{ color:'#ef4444' }}>${EXPENSE_DATA[i].toLocaleString()}</td>
                <td className="text-right" style={{ fontWeight:600, color: net >= 0 ? '#10b981' : '#ef4444' }}>
                  {net >= 0 ? '+' : ''}${net.toLocaleString()}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
);

/* ─── View map ────────────────────────────────────────────── */
const VIEWS = {
  'trial-balance':    { component: <TrialBalanceView />,       title: 'Trial Balance'                                },
  'ledger-report':    { component: <LedgerReportView />,       title: 'Ledger Report'                                },
  'balance-sheet':    { component: <BalanceSheetView />,       title: 'Balance Sheet'                                },
  'ar-ageing-summary':{ component: <ARAgeingSummaryView />,    title: 'Account Receivable Ageing Report (Summary)'   },
  'ap-ageing-summary':{ component: <APAgeingSummaryView />,    title: 'Account Payable Ageing Report (Summary)'      },
  'ar-ageing-details':{ component: <ARAgeingDetailsView />,    title: 'Account Receivable Ageing Details (Details)'  },
  'ap-ageing-details':{ component: <APAgeingDetailsView />,    title: 'Account Payable Ageing Details (Details)'     },
  'income-vs-expense':{ component: <IncomeVsExpenseView />,    title: 'Income vs Expense'                            },
};

/* ─── Report Card ─────────────────────────────────────────── */
const ReportCard = ({ card, onView }) => (
  <div
    style={{
      background: '#fff',
      border: '1px solid #e2e8f0',
      borderRadius: '8px',
      padding: '1.5rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.75rem',
      boxShadow: '0 1px 3px rgba(0,0,0,0.07)',
      position: 'relative',
      overflow: 'hidden',
    }}
  >
    {/* Gold bottom accent bar */}
    <div style={{ position:'absolute', bottom:0, left:0, right:0, height:'3px', background:'linear-gradient(90deg,#f59e0b,#fbbf24)' }} />
    <h3 style={{ margin:0, fontSize:'1rem', fontWeight:700, color:'#1e293b' }}>{card.title}</h3>
    <p style={{ margin:0, fontSize:'0.85rem', color:'#64748b', lineHeight:1.6, flexGrow:1 }}>{card.description}</p>
    <div>
      <button
        onClick={() => onView(card.id)}
        style={{
          background: '#5b21b6',
          color: '#fff',
          border: 'none',
          borderRadius: '6px',
          padding: '0.5rem 1.25rem',
          fontSize: '0.875rem',
          fontWeight: 600,
          cursor: 'pointer',
          transition: 'background 0.2s',
        }}
        onMouseEnter={e => e.target.style.background = '#4c1d95'}
        onMouseLeave={e => e.target.style.background = '#5b21b6'}
      >
        View Report
      </button>
    </div>
  </div>
);

/* ─── Main Component ──────────────────────────────────────── */
const AccountingReports = () => {
  const [activeView, setActiveView] = useState(null); // null = report cards home

  if (activeView) {
    const view = VIEWS[activeView];
    return (
      <div className="accounting-page">
        {/* Header */}
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:'0.75rem', marginBottom:'0.5rem' }}>
          <div style={{ display:'flex', alignItems:'center', gap:'0.75rem' }}>
            <button
              onClick={() => setActiveView(null)}
              style={{ background:'#f1f5f9', border:'1px solid #e2e8f0', borderRadius:'6px', padding:'0.4rem 0.9rem', cursor:'pointer', fontSize:'0.875rem', color:'#475569', fontWeight:600, display:'flex', alignItems:'center', gap:'0.4rem' }}
            >
              ← Back to Reports
            </button>
            <h2 style={{ margin:0, fontSize:'1.1rem', fontWeight:700, color:'#1e293b' }}>{view.title}</h2>
          </div>
          <div style={{ display:'flex', gap:'0.5rem' }}>
            <button style={{ background:'#fff', border:'1px solid #e2e8f0', padding:'0.45rem 1rem', borderRadius:'6px', fontSize:'0.875rem', fontWeight:600, color:'#334155', cursor:'pointer', display:'flex', alignItems:'center', gap:'0.4rem' }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
              Export PDF
            </button>
            <button style={{ background:'#f1f5f9', border:'1px solid #e2e8f0', padding:'0.45rem 1rem', borderRadius:'6px', fontSize:'0.875rem', fontWeight:600, color:'#334155', cursor:'pointer' }}>
              🖨 Print
            </button>
          </div>
        </div>

        {/* Report content */}
        {view.component}

        {/* Also show Income vs Expense inline for relevant views */}
      </div>
    );
  }

  /* ── Report Cards Grid (home) ── */
  return (
    <div className="accounting-page">
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
          gap: '1.25rem',
        }}
      >
        {REPORT_CARDS.map(card => (
          <ReportCard key={card.id} card={card} onView={setActiveView} />
        ))}
        {/* Income vs Expense card */}
        <ReportCard
          key="income-vs-expense"
          card={{
            id: 'income-vs-expense',
            title: 'Income vs Expense',
            description: 'View a monthly bar chart comparison of your total income against total expenses, with a detailed breakdown per month.',
          }}
          onView={setActiveView}
        />
      </div>
    </div>
  );
};

export default AccountingReports;
